
import { Vue, Component, Prop } from "vue-property-decorator";

interface AdditionalNotesData {
    additional_special_instructions: string;
    additional_general_notes: string;
    additional_other_information: string;
}

@Component
export default class AdditionalNotes extends Vue {
  @Prop({ required: true }) readonly data!: AdditionalNotesData;
}
